import { render, staticRenderFns } from "./IndustryNewsListFilter.vue?vue&type=template&id=10fc4c78&scoped=true"
import script from "./IndustryNewsListFilter.vue?vue&type=script&lang=js"
export * from "./IndustryNewsListFilter.vue?vue&type=script&lang=js"
import style0 from "./IndustryNewsListFilter.vue?vue&type=style&index=0&id=10fc4c78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fc4c78",
  null
  
)

export default component.exports